import { render, staticRenderFns } from "./MyRefundList4.vue?vue&type=template&id=0f480687&scoped=true&"
import script from "./MyRefundList4.vue?vue&type=script&lang=js&"
export * from "./MyRefundList4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f480687",
  null
  
)

export default component.exports